import { useEffect } from "react";
import { useDatePicker, useDatePickerFace } from "src/components/DatePicker";
import { usePageConfigProviderContext } from "..";
import { OutputDateRange } from "../types/OutputDateRange";

type DateRangePickerProps = {
  type: "date" | "dateTime";
  inputConfig?: Partial<useDatePickerFace>;
  onDateRangePicked: (dateRange: OutputDateRange) => void;
};

const DateRangePicker = (props: DateRangePickerProps) => {
  const { type, inputConfig, onDateRangePicked } = props;
  const { isResetClicked } = usePageConfigProviderContext();

  const DateObj = {
    Date: useDatePicker(inputConfig),
  };

  useEffect(() => {
    if (!isResetClicked) return;
    DateObj.Date.resetDate();
  }, [isResetClicked]);

  useEffect(() => {
    onDateRangePicked({
      start: DateObj.Date.start,
      end: DateObj.Date.end,
    });
  }, [DateObj.Date.start, DateObj.Date.end]);

  return <DateObj.Date.Picker type={type} />;
};
export default DateRangePicker;
